module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAMdJREFUOE+tlNsNAiEQRc8UYRm+OjBmrUH7sA770BrUbAk+2rCIMSSDWchA3A18wnC4DPciNBrSiMMPpKor4AQcRORTO0BVZ8AZOIrIM9QOQT2wAV7ArgQzyBVYAr2IbHNQOOUOzIE30OWwDJLUJD2yQhdWgySKYk88mK3dgEVJrftqBhtuDKwixFWUKYuwMO32LdYXfZSpmgZqcjUH0o1utgeJXqqtTTWkawMvItXXyZS5EVlbaPd/hvZioX1UfTT2e2n2H30BEImEE3Nua3cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/关闭@2x.png
// module id = x3B3
// module chunks = 54